import { postForm, getCountries, getStates, getCities } from "@/services/form.service";
import { getClassTempListByCityId } from "@/services/class-temp.service";

import moment from "moment";
// initial state
const state = () => ({
  formModel: {},

  countryList: [],
  stateList: [],
  cityList: [],

  classTempList: [],

  postedCardModel: {
    dialog: false,
    icon: "mdi-check",
    msg: "Kaydınız Başarılı Bir Şekilde Oluşturuldu.",
    text: "Lütfen E-Posta Adresinizi Kontrol Ediniz.",
    color: "white",
  },
});

// mutations
const mutations = {
  setFormModel(state, data) {
    state.formModel = data;
  },

  setCountryList(state, data) {
    state.countryList = data;
  },
  setStateList(state, data) {
    state.stateList = data;
  },
  setCityList(state, data) {
    state.cityList = data;
  },

  setClassTempList(state, data) {
    state.classTempList = data;
  },

  setPostedCardModel(state, data) {
    state.postedCardModel = data;
  },
};

// actions
const actions = {
  async loadClassTempListByCityId(vuexContext) {
    return await getClassTempListByCityId(vuexContext.state.formModel.citiesId).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.newStartDate = moment(item.startDate).format("HH:mm");
        item.newEndDate = moment(item.endDate).format("HH:mm");
        item.label = `${item.newStartDate} - ${item.newEndDate}`;
      });
      vuexContext.commit("setClassTempList", data);

      return data;
    });
  },

  async loadCountryList(vuexContext) {
    return await getCountries().then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
      });
      vuexContext.commit("setCountryList", data);
      return data;
    });
  },

  async loadStateListByCountryId(vuexContext, countryId) {
    return await getStates(countryId).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
      });
      vuexContext.commit("setStateList", data);
      return data;
    });
  },

  async loadCityListByStateId(vuexContext, stateId) {
    return await getCities(stateId).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
      });
      vuexContext.commit("setCityList", data);
      return data;
    });
  },

  async postForm(vuexContext, data) {
    const response = await postForm(data);
    return response.data;
  },

  addStateList(vuexContext, data) {
    vuexContext.commit("setStateList", data);
  },
  addCityList(vuexContext, data) {
    vuexContext.commit("setCityList", data);
  },

  addFormModel(vuexContext, data) {
    vuexContext.commit("setFormModel", data);
  },

  addPostedCardModel(vuexContext, data) {
    vuexContext.commit("setPostedCardModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
